module.exports = __webpack_public_path__ + "static/media/Test.4c9a0227.jpg";